module.exports = __webpack_public_path__ + "img/BCH-alt.39228af0.svg";